import { mdiMagnify } from "@mdi/js";
import Icon from "@mdi/react";
import { ChangeEvent, useEffect, useState } from "react";

import Input from "components/Input";
import FactoringCompany from "features/main/HaulPay/Shared/FactoringCompany";
import useDebounce from "hooks/useDebounce";
import { IFactoringCompany } from "models/HaulPay";
import { getFactoringCompanyAPI } from "services/api/haulpay";
import styles from "./style.module.scss";

interface IProps {
  factoring_id: string;
  company?: IFactoringCompany;
  onCompanySelected?: (company: IFactoringCompany) => void;
}

export default function FactoringCompanySelect({
  factoring_id,
  company,
  onCompanySelected
}: Readonly<IProps>) {
  const [isLoading, setIsLoading] = useState(true);
  const [factoringCompanies, setFactoringCompanies] = useState<IFactoringCompany[]>([]);
  const [searchValue, setSearchValue] = useState("");
  const debouncedSearch = useDebounce(searchValue, 500);

  const handleValueChange = (event: ChangeEvent) => {
    setSearchValue((event.target as HTMLInputElement).value);
  };

  const handleClickCompany = (company: IFactoringCompany) => {
    setSearchValue(company.name);
    if (onCompanySelected) onCompanySelected(company);
  };

  useEffect(() => {
    if (company) setSearchValue(company.name);
  }, [company]);

  useEffect(() => {
    const fetchCompany = async () => {
      if (factoring_id) {
        setIsLoading(true);
        const { data: factoringCompanyResult } = await getFactoringCompanyAPI(debouncedSearch);
        setFactoringCompanies(factoringCompanyResult.results);
        setIsLoading(false);
      }
    };

    fetchCompany();
  }, [debouncedSearch]);

  return (
    <div className={styles.searchShipperDebtorContainer}>
      <Input
        value={searchValue}
        isLoading={isLoading}
        onChange={handleValueChange}
        prefixNode={<Icon path={mdiMagnify} className={styles.searchIcon} />}
      />
      {!isLoading &&
        (factoringCompanies ? (
          factoringCompanies.map((company) => (
            <FactoringCompany
              key={company.id}
              factoring_company={company}
              onClickCompany={() => handleClickCompany(company)}
            />
          ))
        ) : (
          <div className={styles.noListText}>
            <span>You didn’t find the company? </span>
            <a className="underline text-info">Click here to add</a>
          </div>
        ))}
    </div>
  );
}
